import Vue from 'vue'

/**
 *获取公司设备列表
 * @param {*} params
 */
export const findDevicesByCompanyId = (params) => {
  return Vue.fetch.post('/apiv1/hr/device/findByCmpId', params)
}

export const checkDevice = (params) => {
  return Vue.fetch.post('/apiv1/hr/device/offLineCheck', params)
}



// WEBPACK FOOTER //
// ./src/services/companyDevicesApi.js